import PropTypes from 'prop-types';
import React, {useContext} from 'react';
import NumberFormat from 'react-number-format';
import {setNumberRounding, setThousandSeparator} from '../../../../../util/utils';
import EllipsesControl from '../../../../Common/EllipsesControl/EllipsesControl';
import {useUserPreferences} from '../../../../../util/customHooks';

/* This component was made to refactor TEMateriality inner function. */
function TEMaterialityDisplayNumber({className, value, suffix, isDecimal}) {
	const userPreferences = useUserPreferences();
	const valFormatter = setThousandSeparator(userPreferences.numberFormat);

	if (value) {
		const formattedNumber = (
			<NumberFormat
				value={isDecimal ? value : setNumberRounding(userPreferences.roundingFormat, value)}
				thousandSeparator={valFormatter.thousandSeparator}
				decimalSeparator={valFormatter.decimalSeparator}
				thousandsGroupStyle={valFormatter.thousandsGroupStyle}
				decimalScale={isDecimal ? 1 : 0}
				fixedDecimalScale={!isDecimal}
				displayType="text"
				suffix={suffix}
			/>
		);

		return (
			<section className={className}>
				<EllipsesControl content={formattedNumber} tooltip={formattedNumber} noOfLines={1} />
			</section>
		);
	} else {
		return <span className={className}>{'-'}</span>;
	}
}

TEMaterialityDisplayNumber.propTypes = {
	className: PropTypes.string,
	value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	suffix: PropTypes.string,
	isDecimal: PropTypes.bool
};

TEMaterialityDisplayNumber.defaultProps = {
	className: 'DisplayAmountCount',
	value: '',
	suffix: '',
	isDecimal: false
};

export default TEMaterialityDisplayNumber;
